import type { Placement } from '@atlaskit/dropdown-menu/types';

export const MENU_WIDTH = {
  PRIMARY: 248,
  SUBMENU: 216,
  DRILLDOWN: 298,
  EXPANDED: 634,
} as const;

export type MenuWidth = (typeof MENU_WIDTH)[keyof typeof MENU_WIDTH];

/**
 * Hover intent delay for submenu open on mouse-enter.
 * Prevents submenu flicker when the pointer sweeps quickly across menu items.
 */
export const HOVER_INTENT_DELAY_MS = 150;
export const SUBMENU_PLACEMENT: Placement = 'right-start';
export const SUBMENU_OFFSET: [number, number] = [-6, 4];
